var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_6681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4087 16.9561C13.062 16.9561 15.213 14.8052 15.213 12.1519C15.213 9.49859 13.062 7.34766 10.4087 7.34766C7.75542 7.34766 5.60449 9.49859 5.60449 12.1519C5.60449 14.8052 7.75542 16.9561 10.4087 16.9561Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4087 16.9561C13.062 16.9561 15.213 14.8052 15.213 12.1519C15.213 9.49859 13.062 7.34766 10.4087 7.34766C7.75542 7.34766 5.60449 9.49859 5.60449 12.1519C5.60449 14.8052 7.75542 16.9561 10.4087 16.9561Z",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59277 20.6526C4.33105 19.5175 5.34114 18.5847 6.53136 17.939C7.72158 17.2933 9.05423 16.9551 10.4083 16.9551C11.7624 16.9551 13.0951 17.2933 14.2853 17.939C15.4755 18.5847 16.4856 19.5175 17.2239 20.6526",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7305 16.3652C19.8582 16.3644 20.9682 16.7102 21.9595 17.3711C22.9509 18.032 23.7921 18.9871 24.4069 20.1495",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8389 8.15253C17.4055 7.92026 18.015 7.81948 18.6238 7.8574C19.2327 7.89532 19.8259 8.071 20.361 8.37189C20.8962 8.67278 21.3601 9.09144 21.7196 9.59797C22.0791 10.1045 22.3252 10.6864 22.4406 11.3021C22.5559 11.9177 22.5375 12.552 22.3867 13.1595C22.2358 13.767 21.9564 14.3328 21.5681 14.8164C21.1799 15.3 20.6926 15.6895 20.1409 15.957C19.5893 16.2246 18.9869 16.3636 18.377 16.3642",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_6681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlack);
export default __webpack_public_path__ + "static/media/user-black.fd35f9aa.svg";
export { ForwardRef as ReactComponent };